import LeadDialog from "./LeadDialog";
import { CONTACT } from "../lib/site";
import { Phone } from "lucide-react";

export function SectionLabel({ children, className = "" }) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <span className="h-px w-10 [background:linear-gradient(to_right,#3b82f6,#10b981)]" />
      <span className="font-mono text-[11px] uppercase tracking-[0.35em] text-white/50">{children}</span>
    </div>
  );
}

// Primary + two secondary CTAs used across the site
export function CTAGroup({ className = "", stacked = false }) {
  return (
    <div className={`flex flex-wrap items-center gap-4 ${stacked ? "flex-col items-start sm:flex-row" : ""} ${className}`}>
      <LeadDialog kind="consultation" variant="primary" testId="cta-book-consultation" />
      <LeadDialog kind="quote" variant="secondary" testId="cta-request-quote" />
      <a
        href={CONTACT.phoneHref}
        data-testid="cta-call-now"
        className="group inline-flex items-center justify-center gap-2 px-8 py-4 text-xs font-500 uppercase tracking-[0.2em] text-white/70 transition-colors hover:text-white"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
    </div>
  );
}
